<template>
  <sdPageHeader title="Pengajuan Pembinaan Person Grade">
    <template #buttons>
      <a-button type="primary" @click="goBack"> <left-outlined /> Kembali </a-button>
    </template>
  </sdPageHeader>
  <Main>
    <sdCards headless>
      <!-- Employee Information Section -->
      <div class="employee-info-section">
        <div class="info-row">
          <div class="info-col">
            <div class="info-item">
              <div class="info-label">NIP</div>
              <div class="info-value">{{ employeeData.nip }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Nama Pegawai</div>
              <div class="info-value">{{ employeeData.namaPegawai }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">PeG</div>
              <div class="info-value">{{ employeeData.peg }}</div>
            </div>
          </div>
          <div class="info-col">
            <div class="info-item">
              <div class="info-label">Jabatan</div>
              <div class="info-value">{{ employeeData.jabatan }}</div>
            </div>
            <div class="info-item">
              <div class="info-label">Personal Area</div>
              <div class="info-value">{{ employeeData.personalArea }}</div>
            </div>
            <!-- <div class="info-item">
              <div class="info-label">PoG</div>
              <div class="info-value">{{ employeeData.pog }}</div>
            </div> -->
          </div>
        </div>
      </div>

      <!-- Filter and Search Section -->
      <div class="filter-search-section">
        <div class="search-input">
          <a-input-search
            v-model="searchQuery"
            placeholder="Cari Jabatan..."
            style="width: 250px"
            @search="handleSearch"
          />
        </div>
      </div>

      <!-- Table Section -->
      <a-table
        :columns="columns"
        :data-source="tableData"
        :loading="loading"
        :pagination="{
          total: pagination.total,
          current: pagination.current,
          pageSize: pagination.pageSize,
          showSizeChanger: pagination.showSizeChanger,
          pageSizeOptions: pagination.pageSizeOptions,
          showTotal: pagination.showTotal,
        }"
        @change="handleTableChange"
        :row-selection="{ type: 'radio', onChange: onSelectionChange }"
      >
        <template #org2="{ text }">
          <span>{{ text }}</span>
        </template>
        <template #org3="{ text }">
          <span>{{ text }}</span>
        </template>
        <template #org4="{ text }">
          <span>{{ text }}</span>
        </template>
      </a-table>

      <!-- Submit Button -->
      <div class="submit-section">
        <a-button type="primary" @click="showConfirmationModal" :disabled="!selectedRow">
          Ajukan
        </a-button>
      </div>

      <!-- Confirmation Modal -->
      <a-modal
        v-model:visible="confirmationModalVisible"
        title="Konfirmasi Melanjutkan"
        :footer="null"
        :closable="true"
        :maskClosable="false"
        @cancel="handleCancelConfirmation"
        class="confirmation-modal"
      >
        <div class="confirmation-content">
          <p>
            Apakah benar akan melanjutkan pengajuan assessment pembinaan Person Grade dengan menyetujui konsekuensi yang
            akan diterima jika memenuhi atau tidak memenuhi?
          </p>

          <div class="confirmation-buttons">
            <a-space>
              <a-button @click="handleCancelConfirmation" danger>
                Batal
              </a-button>
              <a-button type="primary" @click="handleConfirm">
                Ya
              </a-button>
            </a-space>
          </div>
        </div>
      </a-modal>
    </sdCards>
  </Main>
</template>

<script>
import { Main } from '../styled';
import { DownOutlined, LeftOutlined } from '@ant-design/icons-vue';
import { getItem } from '@/utility/localStorageControl';
import assessmentApi from '@/api/assessment';
import { handleSessionExpired } from '@/utility/utility';

const ViewPage = {
  name: 'Pengajuan',
  components: {
    Main,
    DownOutlined,
    LeftOutlined,
  },
  data() {
    // Get profile data from local storage
    const profileData = getItem('profile_plnbb') || {};

    return {
      searchQuery: '',
      selectedRowKey: null,
      selectedRow: null,
      confirmationModalVisible: false,
      employeeData: {
        nip: profileData.nip || '',
        namaPegawai: profileData.name || '',
        peg: profileData.peg || '',
        jabatan: profileData.jabatan || '',
        pog: profileData.pog || '',
        personalArea: profileData.personal_area || '',
      },
      columns: [
        {
          title: 'No',
          dataIndex: 'no',
          key: 'no',
          width: 70,
          align: 'center',
        },
        {
          title: 'Sebutan Jabatan',
          dataIndex: 'sebutanJabatan',
          key: 'sebutanJabatan',
        },
        {
          title: 'PoG',
          dataIndex: 'pog',
          key: 'pog',
          width: 80,
          align: 'center',
        },
        {
          title: 'Jumlah Kebutuhan',
          dataIndex: 'jumlahKebutuhan',
          key: 'jumlahKebutuhan',
          align: 'center',
        },
        {
          title: 'Org Level 2',
          dataIndex: 'orgLevel2',
          key: 'orgLevel2',
          slots: { customRender: 'org2' },
        },
        {
          title: 'Org Level 3',
          dataIndex: 'orgLevel3',
          key: 'orgLevel3',
          slots: { customRender: 'org3' },
        },
        {
          title: 'Org Level 4',
          dataIndex: 'orgLevel4',
          key: 'orgLevel4',
          slots: { customRender: 'org4' },
        },
      ],
      tableData: [],
      loading: false,
      pagination: {
        total: 0,
        current: 1,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => `Menampilkan ${range[0]}-${range[1]} dari ${total} Data`,
        onChange: () => {}, // Empty function to be filled by handleTableChange
        onShowSizeChange: () => {}, // Empty function to be filled by handleTableChange
      },
    };
  },
  created() {
    // Load employee data from profile when component is created
    this.loadEmployeeData();
    // Fetch table data from API
    this.fetchTableData();
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    fetchTableData() {
      // Show loading state
      this.loading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Prepare query parameters for pagination
      const params = {
        page: this.pagination.current,
        per_page: this.pagination.pageSize,
      };

      // Add search query if present - specifically for jabatan (position title)
      if (this.searchQuery) {
        params.jabatan = this.searchQuery.toUpperCase();
      }

      // Fetch data from the API
      assessmentApi
        .get('proyeksi-jabatan', {
          headers,
          params,
        })
        .then(response => {
          if (response.data && response.data.data) {
            // Check if the data is paginated
            const apiData = response.data.data.data || response.data.data;

            // Map API data to table format
            this.tableData = apiData.map((item, index) => ({
              key: item.id.toString(),
              no: index + 1,
              sebutanJabatan: item.jabatan,
              pog: item.pog.toString(),
              jumlahKebutuhan: item.jumlah_kebutuhan,
              orgLevel2: item.org_level_2 || '',
              orgLevel3: item.org_level_3 || '',
              orgLevel4: item.org_level_4 || '',
              status: item.status,
              jumlahTerisi: item.jumlah_terisi,
            }));

            // Update pagination with API pagination data if available
            const paginationInfo = response.data.data;
            this.pagination = {
              ...this.pagination,
              total: paginationInfo.total || apiData.length,
              current: paginationInfo.current_page || this.pagination.current,
              pageSize: paginationInfo.per_page || this.pagination.pageSize,
              // Preserve the callback functions
              onChange: page => {
                this.pagination.current = page;
                this.fetchTableData();
              },
              onShowSizeChange: (current, size) => {
                this.pagination.current = current;
                this.pagination.pageSize = size;
                this.fetchTableData();
              },
            };
          }
        })
        .catch(error => {
          console.error('Error fetching table data:', error);
          this.$message.error('Gagal memuat data proyeksi jabatan');
          if (error.response && error.response.status === 401) {
            handleSessionExpired();
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    loadEmployeeData() {
      const profileData = getItem('profile_plnbb') || {};

      // Update employeeData with profile information
      this.employeeData = {
        nip: profileData.nip || '',
        namaPegawai: profileData.name || '',
        peg: profileData.peg || '',
        jabatan: profileData.jabatan || '',
        pog: profileData.pog || '',
        personalArea: profileData.personal_area || '',
      };
    },
    handleSearch(value) {
      console.log('Searching for jabatan:', value);
      // Update search query to filter by position title (jabatan)
      this.searchQuery = value;
      // Reset pagination to first page when searching
      this.pagination.current = 1;
      // Fetch data with the search parameter
      this.fetchTableData();
    },
    handleTableChange(pagination, filters, sorter) {
      console.log('Table params changed:', { pagination, filters, sorter });
      // Update pagination state
      this.pagination = {
        ...this.pagination,
        current: pagination.current,
        pageSize: pagination.pageSize,
        // Update the callback functions
        onChange: page => {
          this.pagination.current = page;
          this.fetchTableData();
        },
        onShowSizeChange: (current, size) => {
          this.pagination.current = current;
          this.pagination.pageSize = size;
          this.fetchTableData();
        },
      };

      // Fetch data with updated pagination
      this.fetchTableData();
    },
    onSelectionChange(selectedRowKeys, selectedRows) {
      this.selectedRowKey = selectedRowKeys[0];
      this.selectedRow = selectedRows[0];
      console.log('Selected row:', this.selectedRow);
    },
    showConfirmationModal() {
      this.confirmationModalVisible = true;
    },

    handleCancelConfirmation() {
      this.confirmationModalVisible = false;
    },

    handleConfirm() {
      // Process the submission
      console.log('Submitting application for selected position:', this.selectedRow);

      // Show loading state
      this.loading = true;

      // Get access token from localStorage
      const accessToken = getItem('access_token');

      // Set headers with the token
      const headers = {};
      if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
      }

      // Prepare data for submission
      const postData = {
        periode_assessment_id: 1,
        proyeksi_jabatan_id: parseInt(this.selectedRow.key), // Convert the key (id) to integer
      };

      // Get pengajuanId from route params
      const pengajuanId = this.$route.params.pengajuanId;

      // Submit data to the API as an update to existing resource
      assessmentApi
        .put(`pengajuan-assessment/${pengajuanId}`, postData, { headers })
        .then(() => {
          this.$message.success('Pengajuan berhasil diperbarui!');
          this.confirmationModalVisible = false;

          // Redirect to assessment routes
          this.$router.push({ name: 'pembinaan' });
        })
        .catch(error => {
          console.error('Error updating application:', error);
          this.$message.error('Gagal memperbarui pengajuan. Silakan coba lagi.');
          this.confirmationModalVisible = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};

export default ViewPage;
</script>

<style scoped>
.confirmation-modal {
  .confirmation-content {
    padding: 0 16px;
  }

  p {
    margin-bottom: 24px;
    line-height: 1.6;
    text-align: center;
  }

  .confirmation-buttons {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    padding: 16px 0;
  }
}

.employee-info-section {
  background-color: #f9f9f9;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 24px;
}

.info-row {
  display: flex;
  flex-wrap: wrap;
}

.info-col {
  flex: 1;
  min-width: 300px;
}

.info-item {
  margin-bottom: 12px;
}

.info-label {
  font-size: 14px;
  color: #8c8c8c;
  margin-bottom: 4px;
}

.info-value {
  font-size: 16px;
  font-weight: 500;
}

.filter-search-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
}

.submit-section {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

.ant-table {
  margin-top: 16px;
}
</style>
